import { useLayoutEffect, useRef } from 'preact/hooks'

const useLatestRef = <T>(value: T) => {
  const ref = useRef(value)

  useLayoutEffect(() => {
    ref.current = value
  })

  return ref
}

export default useLatestRef
